import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { ResultServerActionType } from '@headless-workspace/core-domain';
import {
    getProductSetInfoServerAction,
    ProductSetDynamicInfo,
} from '../../../../../server/lib/productDetail/services/getProductSetInfoServerAction';
import { useSafeSWRMutation } from '../../../hooks';
import '../../../user';

type GetProductSetInfoArgs = {
    productId: string;
    variantIds: string[];
};

type UseProductSetInfoMutationReturnType = {
    getProductSetInfo: ({
        productId,
        variantIds,
    }: GetProductSetInfoArgs) => Promise<ResultServerActionType<ProductSetDynamicInfo>>;
    isGettingProductSetInfo: boolean;
};

export const useProductSetInfoMutation = (): UseProductSetInfoMutationReturnType => {
    const { trigger: getProductSetInfo, isMutating: isGettingProductSetInfo } = useSafeSWRMutation(
        CacheKeys.ProductSetInfo,
        ServerActionName.getProductSetInfo,
        (_, { arg }: { arg: GetProductSetInfoArgs }) => {
            return getProductSetInfoServerAction(arg);
        },
    );
    return { getProductSetInfo, isGettingProductSetInfo };
};
